import { InjectionToken } from "@angular/core";
import { TableConfig } from "@shared/components/table-implementation/types/table-config";

export const TABLE_DEFAULT_CONFIG: InjectionToken<TableConfig> = new InjectionToken<TableConfig>("TABLE_DEFAULT_CONFIG");
